import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from './ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <motion.button
      className="theme-toggle"
      onClick={toggleTheme}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {/* Icono solo - visible en colapsado */}
      <div className="toggle-icon-only">
        {isDark ? <Moon size={16} /> : <Sun size={16} />}
      </div>
      
      {/* Track completo - visible en expandido */}
      <div className="toggle-track">
        <motion.div
          className="toggle-thumb"
          animate={{ x: isDark ? 20 : 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
        >
          {isDark ? <Moon size={12} /> : <Sun size={12} />}
        </motion.div>
      </div>
    </motion.button>
  );
};

export default ThemeToggle;
